import { render } from "./measure-datatable.vue?vue&type=template&id=115335b1&scoped=true&ts=true"
import script from "./measure-datatable.ts?vue&type=script&lang=ts"
export * from "./measure-datatable.ts?vue&type=script&lang=ts"

import "./measure-datatable.scss?vue&type=style&index=0&id=115335b1&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115335b1"]])

export default __exports__